module.exports = __webpack_public_path__ + "img/what.b138595c.svg";